<template>
  <div class="bordered">

    <div class="container-fill">
      <div>
        <div class="title">
          {{activity.operation}} <span class="subtitle">({{activity.asset_type}} - {{ activity.asset_value }})</span>
        </div>
      </div>
      <div class="subtitle">
        <div>
          (timestamp: <span class="bold">{{ activity.timestamp }}</span>)
        </div>
      </div>
    </div>
      
    <pre class="debug" v-show="debugMode">{{activity}}</pre>
    
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#profileButtons {
  display: inline-block;
  float: right;
}
.default {
  font-size: small;
}
.container {
  display: flex;
}
.container-fill {
  display: flex;
  justify-content: space-between;
}
.details {
  margin-top: 5px;
  border-top: 1px solid #cccccc;
  padding-top: 5px;
}
.details-header {
  font-size: small;
}
.details-header > h2,h3,h4 {
  font-size: initial;
  margin: 0px;
}
.title {
  font-size: 16px;
  font-weight: bold;
}
.subtitle {
  font-size: 14px;
  font-weight: normal;
}
.bold {
  font-weight: bold;
}
</style>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    activity: {
      type: Object,
      required: true
    }
  },
  computed: { 
    ...mapState([
      'debugMode'
    ])
  },
  data () {
    return {             
          isActive: false   
        }      
  },  
  methods: {
  }
}
</script>
